import React from 'react';
import { detailCardClass, detailItemClass, sectionTitleClass, secondaryButtonClass } from './ui';

const isUuid = (value) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || '')
  );

const Value = ({ value }) => (
  <span className={`text-slate-700 ${isUuid(value) ? 'font-mono' : ''}`}>{value}</span>
);

const PartnerDetails = ({ details, onAddApplication }) => {
  const {
    partnerId = '-',
    userId = '-',
    displayInDirectory = '-',
    hourlyLimit = '-',
    monthlyLimit = '-',
    partnerCreatedAt = '-',
    partnerUpdatedAt = '-',
    partnerDeletedAt = '-',
  } = details || {};

  return (
    <div className={detailCardClass}>
      <div className="mb-2 flex items-center justify-between gap-3">
        <h4 className={sectionTitleClass}>Partner Details</h4>
        <button type="button" onClick={onAddApplication} className={secondaryButtonClass}>
          Add Application
        </button>
      </div>
      <div className="grid grid-cols-1 gap-2 text-xs md:grid-cols-2">
        <div className={detailItemClass}><span className="font-medium text-slate-800">Partner ID:</span> <Value value={partnerId} /></div>
        <div className={detailItemClass}><span className="font-medium text-slate-800">User ID:</span> <Value value={userId} /></div>
        <div className={detailItemClass}><span className="font-medium text-slate-800">Display In Directory:</span> <Value value={displayInDirectory} /></div>
        <div className={detailItemClass}><span className="font-medium text-slate-800">Hourly Limit:</span> <Value value={hourlyLimit} /></div>
        <div className={detailItemClass}><span className="font-medium text-slate-800">Monthly Limit:</span> <Value value={monthlyLimit} /></div>
        <div className={detailItemClass}><span className="font-medium text-slate-800">Created At:</span> <Value value={partnerCreatedAt} /></div>
        <div className={detailItemClass}><span className="font-medium text-slate-800">Updated At:</span> <Value value={partnerUpdatedAt} /></div>
        <div className={`${detailItemClass} md:col-span-2`}><span className="font-medium text-slate-800">Deleted At:</span> <Value value={partnerDeletedAt} /></div>
      </div>
    </div>
  );
};

export default PartnerDetails;
